(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FranchiseTaxInfoChangeName',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// monitor name changes
		$('.monitor-changes').on('keyup change', function click(e)
		{
			var $self   = $(this),
			    origVal = $self.data('original'),
			    newVal  = $self.val();

			if (origVal === newVal) {
				$('#franchisetaxinfochangename-franchise_tax_info-name_changed').val('0');
				// $('#address_change_warning').addClass('hidden');
			} else {
				$('#franchisetaxinfochangename-franchise_tax_info-name_changed').val('1');
				// $('#address_change_warning').removeClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
